module.exports = __webpack_public_path__ + "media/images/brand/share-88ffab4836ab88dcca81801bc4e22f17.svg";